import { render } from "./InputNumber.vue?vue&type=template&id=784b18a2"
import script from "./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue?vue&type=script&lang=js"
script.render = render

export default script